import React from 'react'

import { MarketSegmentFilter } from '@/components/ListFilter'

import HomeReadiness from './HomeReadiness'
import OtaTickets from './OtaTickets'
import ScheduledCommunications from './ScheduledCommunications'
import Supply from './Supply'
import Tickets from './Tickets'

export const Dashboard: React.FC = () => {
  return (
    <div className="flex max-h-screen w-full flex-col overflow-y-scroll p-4 md:p-8">
      <div className="mb-4 flex w-full flex-row items-center  justify-end">
        <MarketSegmentFilter />
      </div>
      <ScheduledCommunications />
      <Tickets />
      <OtaTickets />
      <HomeReadiness />
      <Supply />
    </div>
  )
}
